import { createSelector } from 'reselect';

export const getCurrentPageNumberSelector = createSelector(
  (state, match) => {
    if (!match) {
      return 1;
    }
    return +match.params.pageNumber || 1;
  },
  (pageNumber) => +pageNumber
);

export * from './channels';
export * from './collection';
export * from './integration';
export * from './navigation';
export * from './settings';
export * from './user';
export * from './users';
export * from './video-comments';
export * from './website';
export { getFooterElements } from 'common/selectors/settings';
export {
  getShowVideoUploaderSelector,
  getVideoDisplaySettingsSelector as getVideoDisplaySettings,
} from 'common/selectors/settings';
